<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="javascript:;">首页</a></li>
                <li><a href="javascript:;">发票管理</a></li>
                <li><a href="invoiceaddressmanage">邮寄地址管理</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>发票邮寄地址管理</span></div>
            <ol style="font-size: 12.5px;">
                当前共<label class="title_top1">{{list.length}}</label>个地址，最多保存<label class="title_top1">5</label>个地址。
                <el-button type="primary" plain class="top_button" :disabled="list.length < 5 ? false : true" @click="showadd()">添加新地址</el-button>
            </ol>
            <div id="usual1" class="usual"> 
                <div id="tab1" class="tabson">                
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th>收件人姓名</th>
                                <th>电话号码</th>
                                <th>收件地址</th>
                                <th>邮编</th>
                                <th>邮箱地址</th>
                                <th>开票类型</th>
                                <th>操作</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list">
                                <td>{{item.recipient}}</td>
                                <td>{{item.mobile}}</td>
                                <td>{{item.address}}</td>
                                <td>{{item.code}}</td>
                                <td>{{item.email}}</td>
                                <td>{{item.invoicetype}}</td>
                                <template v-if="item.status == '1'">
                                    <td>
                                        <el-button type="text" style="color:red;">默认地址</el-button>
                                        <el-button type="text" @click="showupdate(index)">修改</el-button>
                                        <el-button type="text" @click="del(item.id)">删除</el-button>
                                    </td>
                                </template>
                                <template v-else-if="item.status == '0'">
                                    <td @mouseover="setmoren()" @mouseout="resetmoren()">
                                        <el-button type="text" v-show="moren" @click="updatestatus(item.id)">设为默认</el-button>
                                        <el-button type="text" @click="showupdate(index)">修改</el-button>
                                        <el-button type="text" @click="del(item.id)">删除</el-button>
                                    </td>
                                </template>
                            </tr>     
                            <tr v-if="list.length == 0">
                                <td colspan="7">
                                    <div><i class="el-icon-plus" @click="showadd()">添加新地址(最多保存五个)</i></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>

                    <!-- 添加新地址 -->
                    <div v-show="addShow" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                        top: 0; left: 0;display: block;"/>
                    <div class="tip" style="z-index:200;display: block;width:600px;" v-show="addShow">
                        <div class="tiptop"><span>新增发票地址</span><a @click="close();"></a></div>
                        <ul class="forminfo" style="margin-top:10px;">
                            <li>
                                <label>发票类型<b>*</b></label>
                                <el-radio v-model="invoicetype" label="电子发票" border style="width:110px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(0)">电子发票</label>
                                </el-radio>
                                <el-radio v-model="invoicetype" label="普通发票" border style="width:110px;margin-left:10px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(1)">普通发票</label>
                                </el-radio>
                                <el-radio v-model="invoicetype" label="增值税专用发票" border style="width:140px;margin-left:10px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkinvoicetype(2)">增值税专用发票</label>
                                </el-radio>
                            </li>
                            <li>
                                <label>收件人姓名<b>*</b></label>
                                <el-input placeholder="请输入收件人姓名" v-model="recipient" style="width:175px;"></el-input>
                            </li>
                            <!-- <template v-if="invoicetype == '电子发票'">
                                <li>
                                    <label>邮箱地址<b>*</b></label>
                                    <el-input placeholder="请输入邮箱地址" v-model="email" style="width:175px;"></el-input>
                                </li>
                            </template>
                            <template v-else-if="invoicetype == '普通发票' || invoicetype == '增值税专用发票'">
                                <li>
                                    <label>手机号<b>*</b></label>
                                    <el-input placeholder="请输入手机号" v-model="mobile" style="width:175px;"></el-input>
                                </li>
                                <li>
                                    <label>邮编<b>*</b></label>
                                    <el-input placeholder="请输入邮编" v-model="code" style="width:175px;"></el-input>
                                </li>
                                <li>
                                    <label>收货地址<b>*</b></label>
                                    <el-input placeholder="请输入收货地址" v-model="address" style="width:400px;"></el-input>
                                </li>
                            </template> -->
                            <li>
                                <label>手机号<b>*</b></label>
                                <el-input placeholder="请输入手机号" v-model="mobile" style="width:175px;"></el-input>
                            </li>
                            <li>
                                <label>邮编<b>*</b></label>
                                <el-input placeholder="请输入邮编" v-model="code" style="width:175px;"></el-input>
                            </li>
                            <li>
                                <label>收货地址<b>*</b></label>
                                <el-input placeholder="请输入收货地址" v-model="address" style="width:400px;"></el-input>
                            </li>
                            <li>
                                <label>邮箱地址<b>*</b></label>
                                <el-input placeholder="请输入邮箱地址" v-model="email" style="width:175px;"></el-input>
                            </li>
                            <el-checkbox v-model="choose" style="margin-left:85px;">设为默认地址</el-checkbox>
                        </ul>
                        <div class="tipbtn">
                            <!-- <template v-if="invoicetype == '电子发票'">
                                <el-button type="primary" style="margin-left:-15px;" :disabled="email.trim().length == 0 || recipient.trim().length == 0 ? true : false" @click="save()">提交并保存</el-button>
                            </template>
                            <template v-if="invoicetype == '普通发票' || invoicetype == '增值税专用发票'">
                                <el-button type="primary" style="margin-left:-15px;" 
                                    :disabled="recipient.trim().length == 0  || mobile.trim().length == 0 || address.trim().length == 0 || code.trim().length == 0 ? true : false" @click="save()">提交并保存</el-button>
                            </template> -->
                            <el-button type="primary" style="margin-left:-15px;" 
                                    :disabled="email.trim().length == 0 || recipient.trim().length == 0  || mobile.trim().length == 0 || address.trim().length == 0 || code.trim().length == 0 ? true : false" @click="save()">提交并保存</el-button>
                        </div> 
                    </div>

                    <!-- 修改邮寄地址 -->
                    <div v-show="update.showupdate" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                        top: 0; left: 0;display: block;"/>
                    <div class="tip" style="z-index:200;display: block;width:600px;" v-show="update.showupdate">
                        <div class="tiptop"><span>修改发票地址</span><a @click="closeupdate();"></a></div>
                        <ul class="forminfo" style="margin-top:10px;">
                            <li>
                                <label>发票类型<b>*</b></label>
                                <el-radio v-model="update.invoicetype" label="电子发票" border style="width:110px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkupdateinvoicetype(0)">电子发票</label>
                                </el-radio>
                                <el-radio v-model="update.invoicetype" label="普通发票" border style="width:110px;margin-left:10px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkupdateinvoicetype(1)">普通发票</label>
                                </el-radio>
                                <el-radio v-model="update.invoicetype" label="增值税专用发票" border style="width:140px;margin-left:10px;">
                                    <label style="margin: -43px 0px 0px 10px;font-size: 14px;cursor: pointer;" @click="checkupdateinvoicetype(2)">增值税专用发票</label>
                                </el-radio>
                            </li>
                            <li>
                                <label>收件人姓名<b>*</b></label>
                                <el-input placeholder="请输入收件人姓名" v-model="update.recipient" style="width:175px;"></el-input>
                            </li>
                            <li>
                                <label>手机号<b>*</b></label>
                                <el-input placeholder="请输入手机号" v-model="update.mobile" style="width:175px;"></el-input>
                            </li>
                            <li>
                                <label>邮编<b>*</b></label>
                                <el-input placeholder="请输入邮编" v-model="update.code" style="width:175px;"></el-input>
                            </li>
                            <li>
                                <label>收货地址<b>*</b></label>
                                <el-input placeholder="请输入收货地址" v-model="update.address" style="width:400px;"></el-input>
                            </li>
                            <li>
                                <label>邮箱地址<b>*</b></label>
                                <el-input placeholder="请输入邮箱地址" v-model="update.email" style="width:175px;"></el-input>
                            </li>
                            <!-- <template v-if="update.invoicetype == '电子发票'">
                                <li>
                                    <label>邮箱地址<b>*</b></label>
                                    <el-input placeholder="请输入邮箱地址" v-model="update.email" style="width:175px;"></el-input>
                                </li>
                            </template>
                            <template v-else-if="update.invoicetype == '普通发票' || update.invoicetype == '增值税专用发票'">
                                <li>
                                    <label>手机号<b>*</b></label>
                                    <el-input placeholder="请输入手机号" v-model="update.mobile" style="width:175px;"></el-input>
                                </li>
                                <li>
                                    <label>邮编<b>*</b></label>
                                    <el-input placeholder="请输入邮编" v-model="update.code" style="width:175px;"></el-input>
                                </li>
                                <li>
                                    <label>收货地址<b>*</b></label>
                                    <el-input placeholder="请输入收货地址" v-model="update.address" style="width:400px;"></el-input>
                                </li>
                            </template> -->
                            <el-checkbox v-model="update.choose" style="margin-left:85px;">设为默认地址</el-checkbox>
                        </ul>
                        <div class="tipbtn">
                            <!-- <template v-if="update.invoicetype == '电子发票'">
                                <el-button type="primary" style="margin-left:-15px;" :disabled="update.email.trim().length == 0 || update.recipient.trim().length == 0 ? true : false" @click="updateinvoiceaddress()">提交并保存</el-button>
                            </template>
                            <template v-if="update.invoicetype == '普通发票' || update.invoicetype == '增值税专用发票'">
                                <el-button type="primary" style="margin-left:-15px;" 
                                    :disabled="update.recipient.trim().length == 0  || update.mobile.trim().length == 0 || update.address.trim().length == 0 || update.code.trim().length == 0 ? true : false" @click="updateinvoiceaddress()">提交并保存</el-button>
                            </template> -->
                            <el-button type="primary" style="margin-left:-15px;" 
                                    :disabled="update.email.trim().length == 0 || update.recipient.trim().length == 0  || update.mobile.trim().length == 0 || update.address.trim().length == 0 || update.code.trim().length == 0 ? true : false" @click="updateinvoiceaddress()">提交并保存</el-button>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import '@/assets/js/jquery.js'
export default {
    data() {
        return{
            list: [],
            pageIndex: 0,
            pageSize: 50,
            totalCount: 0,
            addShow: false,
            invoicetype: '电子发票',
            email: '',
            recipient: '',
            mobile: '',
            address: '',
            code: '',
            choose: false,
            status: 0,
            moren: false,
            update: {
                id: '',
                email: '',
                recipient: '',
                address: '',
                mobile: '',
                code: '',
                invoicetype: '电子发票',
                choose: false,
                status: 0,
                showupdate: false,
                index: -1,
            }
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1)
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            var that = this
            let param = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/invoiceaddressmanage.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.list = res.data.invoiceaddressList;
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        showadd() {
            this.addShow = true;
        },
        close() {
            this.email = '';
            this.recipient = '';
            this.mobile = '';
            this.address = '';
            this.code = '';
            this.invoicetype = '电子发票';
            this.choose = false;
            this.status = 0;
            this.addShow = false;
        },
        checkinvoicetype(invoicetype) {
            if(invoicetype == 0)
            {
                this.invoicetype = "电子发票";
            }
            else if(invoicetype == 1)
            {
                this.invoicetype = "普通发票";
            }
            else if(invoicetype == 2)
            {
                this.invoicetype = "增值税专用发票";
            }
        },
        //新增邮寄地址
        save() {
            if(this.mobile.trim().length != 11)
            {
                this.$message.warning({
                    type: 'warning',
                    message: "请输入11位有效手机号",
                    showClose: true,
                });
                return false;
            }
            if(this.choose)
            {
                this.status = 1
            }
            else
            {
                this.status = 0
            }
            var that = this;
            let param = {'email': this.email, 'recipient': this.recipient, 'mobile': this.mobile, 'address': this.address, 'code': this.code, 'invoicetype': this.invoicetype, 'status': this.status}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/invoice/addinvoiceaddress.json',
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.close();
                    that.pageChange(1);
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        //显示默认地址点击事件
        setmoren() {
            this.moren = true;
        },
        //隐藏默认地址点击事件
        resetmoren() {
            this.moren = false;
        },
        //设置为默认地址
        updatestatus(id) {
            var that = this;
            let param = {'id': id}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/invoice/updatestatus.json',
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "设置默认地址" + res.data.msg
                    });
                    that.pageChange(1);
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        },
        del(id) {
            this.$confirm("您确认删除该地址吗？", '提示', {
                confirmButtonText: '确定', 
                cancelButtonText: '取消',                               
                type: 'warning'
            }).then( () => {
                var that = this
                let param = {'id': id}
                this.$ajax({
                    method: 'post',
                    url: this.GLOBAL.serverSrc + "/invoice/deleteinvoiceaddress.json",
                    data: param,
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        'token': this.GLOBAL.token
                    }
                }).then(function(res) {
                    if('0000000' == res.data.code)
                    {
                        that.$message({
                            type: 'success',
                            message: "删除地址" + res.data.msg
                        });
                        that.pageChange(1);
                    }
                    else
                    {
                        that.$message({
                            type: 'error',
                            message: res.data.msg
                        });
                        return false;
                    }
                })
            }).catch( () => {
                this.$message({
                    duration: 2000,
                    showClose: true,
                    type: 'error',
                    message: '已取消'
                });
            });
        },
        showupdate(index) {
            this.update.index = index;
            this.update.id = this.list[index].id;
            this.update.email = this.list[index].email == undefined || this.list[index].email == null ? "" : this.list[index].email;
            this.update.recipient = this.list[index].recipient == undefined || this.list[index].recipient == null ? "" : this.list[index].recipient;
            this.update.address = this.list[index].address == undefined || this.list[index].address == null ? "" : this.list[index].address;
            this.update.invoicetype = this.list[index].invoicetype == undefined || this.list[index].invoicetype == null ? "电子发票" : this.list[index].invoicetype;
            this.update.mobile = this.list[index].mobile == undefined || this.list[index].mobile == null ? "" : this.list[index].mobile;
            this.update.code = this.list[index].code == undefined || this.list[index].code == null ? "" : this.list[index].code;
            this.update.status = this.list[index].status == undefined || this.list[index].status == null ? "0" : this.list[index].status;
            if(this.update.status == 0)
            {
                this.update.choose = false;
            }
            else if(this.update.status == 1)
            {
                this.update.choose = true;
            }
            this.update.showupdate = true;
        },
        checkupdateinvoicetype(invoicetype) {
            if(invoicetype == 0)
            {
                this.update.invoicetype = "电子发票";
            }
            else if(invoicetype == 1)
            {
                this.update.invoicetype = "普通发票";
            }
            else if(invoicetype == 2)
            {
                this.update.invoicetype = "增值税专用发票";
            }
        },
        closeupdate() {
            this.update.index = -1;
            this.update.id = '';
            this.update.email = '';
            this.update.recipient = '';
            this.update.address = '';
            this.update.invoicetype = '电子发票';
            this.update.mobile = '';
            this.update.code = '';
            this.update.status = 0;
            this.update.choose = false;
            this.update.showupdate = false;
        },
        updateinvoiceaddress() {
            if(this.update.mobile.trim().length != 11)
            {
                this.$message.warning({
                    type: 'warning',
                    message: "请输入11位有效手机号",
                    showClose: true,
                });
                return false;
            }
            if(this.update.choose)
            {
                this.update.status = 1
            }
            else
            {
                this.update.status = 0
            }
            var that = this;
            let param = {'email': this.update.email, 'recipient': this.update.recipient, 'mobile': this.update.mobile, 'address': this.update.address, 'code': this.update.code, 'invoicetype': this.update.invoicetype, 'status': this.update.status, 'id': this.update.id}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/invoice/updateinvoiceaddress.json',
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if('0000000' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: "修改地址" + res.data.msg
                    });
                    that.closeupdate();
                    that.pageChange(1);
                }
                else if('0130002' == res.data.code)
                {
                    that.$message({
                        type: 'success',
                        message: res.data.msg
                    });
                    // that.showupdate(that.update.index);
                }
                else
                {
                    that.$alert(res.data.msg);
                }
            })
        }
    }
}
</script>

<style>
.title_top1{color: red;font-size: 14px;margin:0px 2px 0px 2px;}
.el-icon-plus:hover{color: rgb(68, 139, 233);}
.el-icon-plus{width:260px;cursor: pointer;font-size:13px;letter-spacing:2px;}
.top_button{letter-spacing:2px;}
.el-radio__input{top:-10px;}
</style>



// WEBPACK FOOTER //
// src/components/invoice/invoiceaddressmanage.vue